export default "__VITE_ASSET__Ce$G8haK__"